import React from 'react';
import './Layout.css';
import BaseRouter from '../routes';
class CustomLayout extends React.Component {
      

    render() {
    return (
         <>
         
    <BaseRouter authenticated = {this.props.isAuthenticated}/>
         </>
        )
    };    
}    
export default CustomLayout;    